import { Component, Input, EventEmitter, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent {
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    public translate: TranslateService,
  ) { }

  public closePopup() {
    this.close.emit(false);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/theme/components/pop-up/pop-up.component.ts